import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row, RSelect } from '../../../Component';
import RadioInput from '../../../../pages/components/inputs/RadioInput';
import { ADMIN_ADD_EMPLOYEE_TO_TENANT_MODULE_API, ADMIN_RETRIEVE_EMPLOYEES_NOT_IN_TENANT_MODULE_DATA_API } from '../../../../api/api_data';
import { fail_retrieve_employees_not_in_tenant_module_data, reset_retrieve_employees_not_in_tenant_module_data } from '../../../../reducers/auth_tenant/retrieve_employees_not_in_tenant_module_data_Slice';
import { loading_retrieve_employees_not_in_tenant_module_data, success_retrieve_employees_not_in_tenant_module_data } from '../../../../reducers/auth_tenant/retrieve_employees_not_in_tenant_module_data_Slice';
import { ADD_EMPLOYEE_TO_TENANT_MODULE_ERROR_MSG, ADD_EMPLOYEE_TO_TENANT_MODULE_SUCCESS_MSG, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { formatToSentenceCase, getSelectedOption, messageToast } from '../../../../utils/Utils';
import { useSelector } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import * as app_consts from "../../../../utils/app_consts";
import TextInput from '../../../../pages/components/inputs/TextInput';
import PhoneInput from 'react-phone-input-2';
import { fail_add_employee_to_tenant_module, loading_add_employee_to_tenant_module, reset_add_employee_to_tenant_module, success_add_employee_to_tenant_module } from '../../../../reducers/auth_tenant/add_employee_to_tenant_module_Slice';

const initialState = { first_name: "", last_name: "", mobile_number: "", email_address: "", department: "", position: "", roles: [], creation_type: "", existing_id: "" };

const AdminAddEmployeeToModule = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [sent_data, setSentData] = useState(data);
  const [submit_loading, setSubmitLoading] = useState(false);
  const [submit_error, setSubmitError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [employee_data, setEmployeeData] = useState('');
  const [all_employees, setAllEmployees] = useState([]);

  useEffect(() => {
    setError("");
    setSubmitError("");
    setSentData(data);
    setOpen(isOpen);
    if (isOpen && data)
    {
      retrieve_data(data?.tenant?.id, data?.tenant_module?.module_name);
    }
  }, [isOpen, data]);

  const retrieve_data = (id, module_name) => {
    setError("");
    // Retreive Employees
    dispatch(tenant_auth_actions_helper(loading_retrieve_employees_not_in_tenant_module_data, success_retrieve_employees_not_in_tenant_module_data, fail_retrieve_employees_not_in_tenant_module_data, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${ADMIN_RETRIEVE_EMPLOYEES_NOT_IN_TENANT_MODULE_DATA_API}/${id}/${module_name}`));
  };

  const handle_creation_selection = (typeSelection) => {
    setFormData({ ...initialState, ["creation_type"]: typeSelection });
  };

  // Listener
  const retrieve_employees_not_in_tenant_module_data_listener = useSelector((state) => state.retrieve_employees_not_in_tenant_module_data.retrieve_employees_not_in_tenant_module_data);

  useEffect(() => {
    if (retrieve_employees_not_in_tenant_module_data_listener.status !== app_consts.IDLE)
    {
      if (retrieve_employees_not_in_tenant_module_data_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_employees_not_in_tenant_module_data_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_employees_not_in_tenant_module_data_listener.message);
          messageToast(retrieve_employees_not_in_tenant_module_data_listener.message, app_consts.FAIL);
        } else if (retrieve_employees_not_in_tenant_module_data_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_employees_not_in_tenant_module_data_listener.data);
          setLoading(false);
          return_accounts(retrieve_employees_not_in_tenant_module_data_listener.data?.accounts);
          setAllEmployees(retrieve_employees_not_in_tenant_module_data_listener.data?.accounts);
        }
        dispatch(reset_retrieve_employees_not_in_tenant_module_data());
      }
    }
  }, [retrieve_employees_not_in_tenant_module_data_listener]);


  const return_accounts = (rep) => {
    const accounts = rep?.map((item) => {
      return { label: item?.user?.fullname, value: item?.account?.id };
    });
    setEmployeeData(accounts);
  };

  const handle_existing_id = (e) => {
    const found = all_employees?.find((find_data) => { return e?.value === find_data?.account?.id; });

    setFormData({ ...formData, first_name: found?.user?.first_name, last_name: found?.user?.last_name, mobile_number: found?.account?.mobile_number, email_address: found?.account?.email_address, existing_id: found?.account?.id, existing_id: e.value });
  };

  // Handle Change Function
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddEmployeeRowChange = (role) => {
    let new_roles = formData?.roles || [];

    if (new_roles?.includes(role))
    {
      new_roles = new_roles?.filter((ro) => ro !== role);
    } else
    {
      new_roles.push(role); // Just push the role without re-assigning to new_roles
    }

    setFormData({ ...formData, roles: new_roles });
  };

  const handleSubmitAddEmployeeToModule = () => {
    setSubmitError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_add_employee_to_tenant_module, success_add_employee_to_tenant_module, fail_add_employee_to_tenant_module, ADD_EMPLOYEE_TO_TENANT_MODULE_ERROR_MSG, ADD_EMPLOYEE_TO_TENANT_MODULE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADMIN_ADD_EMPLOYEE_TO_TENANT_MODULE_API}`, { ...formData, tenant_id: sent_data?.tenant?.id, module: sent_data?.tenant_module?.module_name, }));
  };

  // Listener
  const add_employee_to_tenant_module_listener = useSelector((state) => state.add_employee_to_tenant_module.add_employee_to_tenant_module);

  useEffect(() => {
    if (add_employee_to_tenant_module_listener.status !== app_consts.IDLE)
    {
      if (add_employee_to_tenant_module_listener.status === app_consts.LOADING)
      {
        setSubmitLoading(true);
        setSubmitError("");
      } else
      {
        if (add_employee_to_tenant_module_listener.status === app_consts.FAIL)
        {
          setSubmitError(add_employee_to_tenant_module_listener.message);
          messageToast(add_employee_to_tenant_module_listener.message, app_consts.FAIL);
        } else if (add_employee_to_tenant_module_listener.status === app_consts.SUCCESS)
        {
          messageToast(ADD_EMPLOYEE_TO_TENANT_MODULE_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          closeModal();
        }
        setSubmitLoading(false);
        dispatch(reset_add_employee_to_tenant_module());
      }
    }
  }, [add_employee_to_tenant_module_listener]);

  return (
    <>
      <Modal isOpen={open} toggle={submit_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md "}>
        <ModalHeader toggle={submit_loading || loading ? "" : closeModal}>Add Employee to Module</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Employees Data...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        <Col size={12}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              Creation Type<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100 form-control-wrap d-flex flex-row">
                              <RadioInput
                                id={app_consts.EXISTING}
                                label="Existing"
                                className="custom-control custom-control-md custom-radio w-50"
                                handleChange={(e) => handle_creation_selection(e)}
                                name={"creation_type"}
                              />
                              <RadioInput
                                id={app_consts.NEW}
                                label="New"
                                className="custom-control custom-control-md custom-radio w-50"
                                handleChange={(e) => handle_creation_selection(e)}
                                name={"creation_type"}
                              />
                            </div>
                          </div>
                        </Col>
                        {
                          formData?.creation_type === app_consts.EXISTING && (
                            <>
                              <Col lg={12}>
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      <label className="form-label mb text-md" htmlFor="retrunable">
                                        Select Account<span className='text-danger pr-2'>{` *`}</span>
                                      </label>
                                    </label>
                                  </div>
                                  <div className="w-100">
                                    <RSelect
                                      options={employee_data}
                                      className="w-100"
                                      placeholder="Search"
                                      value={getSelectedOption(formData?.existing_id, employee_data)}
                                      onChange={(e) => handle_existing_id(e)}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </>
                          )
                        }
                        <hr />
                        {
                          (formData?.creation_type && (formData?.creation_type === app_consts.EXISTING && formData?.existing_id) || (formData?.creation_type === app_consts.NEW)) && (
                            <>
                              <TextInput
                                label="First Name"
                                type="first_name"
                                id_val="first_name"
                                value={formData?.first_name}
                                colSize="6"
                                required
                                name="first_name"
                                handleChange={handleChange}
                                disabled={formData?.creation_type === app_consts.EXISTING}
                              />
                              <TextInput
                                label="Last Name"
                                type="last_name"
                                id_val="last_name"
                                value={formData?.last_name}
                                colSize="6"
                                required
                                name="last_name"
                                handleChange={handleChange}
                                disabled={formData?.creation_type === app_consts.EXISTING}
                              />
                              {
                                formData?.creation_type === app_consts.EXISTING ?
                                  <>
                                    <TextInput
                                      label="Mobile Number"
                                      type="mobile_number"
                                      id_val="mobile_number"
                                      value={formData?.mobile_number}
                                      colSize="6"
                                      required
                                      name="mobile_number"
                                      handleChange={handleChange}
                                      disabled={formData?.creation_type === app_consts.EXISTING}
                                    />
                                  </>
                                  :
                                  <>
                                    <Col lg="6">
                                      <div className="form-group">
                                        <div className="form-label-group">
                                          <label className="form-label" htmlFor="mobile_number">
                                            Mobile Number<span className='text-danger pr-2'>{`* `}</span>
                                          </label>
                                        </div>
                                        <div className="form-control-wrap">
                                          <PhoneInput
                                            country={"zm"}
                                            value={formData?.mobile_number}
                                            onChange={(phone) => setFormData({ ...formData, mobile_number: phone })}
                                            copyNumbersOnly={false}
                                            inputStyle={{ width: '100%' }}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </>
                              }
                              <TextInput
                                label="Email Address"
                                type="email_address"
                                id_val="email_address"
                                value={formData?.email_address}
                                colSize="6"
                                required
                                name="email_address"
                                handleChange={handleChange}
                                disabled={formData?.creation_type === app_consts.EXISTING}
                              />
                              <TextInput
                                label="Department"
                                type="department"
                                id_val="department"
                                value={formData?.department}
                                colSize="6"
                                required
                                name="department"
                                handleChange={handleChange}
                              />
                              <TextInput
                                label="Position"
                                type="position"
                                id_val="position"
                                value={formData?.position}
                                colSize="6"
                                required
                                name="position"
                                handleChange={handleChange}
                              />
                              <div className="form-group">
                                <label className="form-label">Roles<span className='text-danger pr-2'>{`* `}</span></label>
                                <ul className="custom-control-group g-3 align-center">

                                  {
                                    page_data?.roles && page_data?.roles?.length > 0 && page_data?.roles?.map((role) => {
                                      return (
                                        <>
                                          <li>
                                            <div className="custom-control custom-control-sm custom-checkbox">
                                              <input onChange={() => handleAddEmployeeRowChange(role)} checked={formData?.roles?.includes(role)} type="checkbox" className="custom-control-input" id={role} />
                                              <label className="custom-control-label" style={{ fontSize: "18px" }} htmlFor={role}>
                                                {formatToSentenceCase(role)}
                                              </label>
                                            </div>
                                          </li>
                                        </>
                                      );
                                    }
                                    )}
                                </ul>
                              </div>
                            </>
                          )
                        }
                        {submit_error && (
                          <div className="mb-3 w-100">
                            <Alert color="danger" className="alert-icon">
                              <Icon name="alert-circle" /> {submit_error}{" "}
                            </Alert>
                          </div>
                        )}
                        <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                          <Button onClick={handleSubmitAddEmployeeToModule} disabled={submit_loading || !(formData?.first_name && formData?.last_name && formData?.roles?.length > 0 && formData?.position && formData?.email_address && formData?.mobile_number && (formData?.creation_type === app_consts.EXISTING ? formData?.existing_id : true))} color="primary">
                            {submit_loading ? <Spinner size="sm" color="light" /> : "Add Employee to Module"}
                          </Button>
                        </Col>
                      </Row>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default AdminAddEmployeeToModule;